import React, { FC } from "react";
import { TFunction } from "i18next";
import TaskGantt from "../../TaskGantt";
import { CalendarPeriod } from "../calendarPeriod";
import { CalendarEvent } from "../types";
import { TaskCalendarToolbar } from "./TaskCalendarToolbar";

interface TaskGanttPanelProps {
  t: TFunction;
  events: CalendarEvent[];
  currentPeriod: CalendarPeriod;
  anchorDate: Date;
  rangeStart: Date;
  rangeEnd: Date;
  onDatesChange: (period: CalendarPeriod, start: Date, end: Date) => void;
}

export const TaskGanttPanel: FC<TaskGanttPanelProps> = ({
  t,
  events,
  currentPeriod,
  anchorDate,
  rangeStart,
  rangeEnd,
  onDatesChange,
}) => (
  <>
    <TaskCalendarToolbar
      t={t}
      currentPeriod={currentPeriod}
      anchorDate={anchorDate}
      onDatesChange={onDatesChange}
    />
    <TaskGantt events={events} rangeStart={rangeStart} rangeEnd={rangeEnd} />
  </>
);
